module.exports = __webpack_public_path__ + "static/herobackdrop-4d6b72644b8ba7d7529ad715018b978d.jpg";